import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Camera } from 'lucide-react';
import { Button } from '../components/ui/button';
import { GALLERY_IMAGES } from '../mock';

export const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Tous' },
    { id: 'wedding', name: 'Mariages' },
    { id: 'party', name: 'Soirées' },
    { id: 'celebration', name: 'Célébrations' },
    { id: 'setup', name: 'Installations' }
  ];

  const filteredImages = selectedCategory === 'all'
    ? GALLERY_IMAGES
    : GALLERY_IMAGES.filter(img => img.category === selectedCategory);

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero with Background */}
      <section className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <div 
          className="absolute inset-0 -z-10"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1639801528350-6127e867459d?w=1920)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-captiva-beige/90 to-captiva-gold-dark/90 -z-10" />
        <div className="max-w-4xl mx-auto text-center relative">
          <Camera className="h-16 w-16 mx-auto mb-6 text-white" />
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Galerie
          </h1>
          <p className="text-xl text-white/90 leading-relaxed">
            Découvrez nos photobooths en action lors d'événements mémorables à travers toute la Belgique
          </p>
        </div>
      </section>

      {/* Filter */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((category) => (
              <Button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                variant={selectedCategory === category.id ? 'default' : 'outline'}
                className={
                  selectedCategory === category.id
                    ? 'bg-captiva-gold hover:bg-captiva-gold-dark text-white'
                    : 'border-captiva-gold text-captiva-gold hover:bg-captiva-cream'
                }
              >
                {category.name}
              </Button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 aspect-square cursor-pointer"
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-white text-lg font-semibold">{image.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <div className="text-center py-20">
              <p className="text-xl text-gray-500">Aucune image dans cette catégorie</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-captiva-cream to-captiva-cream-dark">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Votre événement sera le prochain
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Créez des souvenirs inoubliables avec nos photobooths premium
          </p>
          <Link to="/contact">
            <Button
              size="lg"
              className="bg-captiva-gold hover:bg-captiva-gold-dark text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Réserver maintenant
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
